import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitTo'
})
export class LimitToPipe implements PipeTransform {

  itemsArray=[];
  transform(items: any, searchText: any ): any[] {
    this.itemsArray=[];
    if(typeof items=='object'){
      for(let i=0;i<parseInt(searchText);i++){
        this.itemsArray.push(items[i]);
      }
      return this.itemsArray;
    }
    else{
      let limit = searchText ? parseInt(searchText, 10) : 10;
      return items.length > limit ? items.substring(0, limit):items
    }    
  }
}